// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"0766510e","133":"c1b9ee84"}[chunkId] + ".chunk.js";
};